<template>
	<div class="cmplay-home-container">
		<HeaderComponent></HeaderComponent>
		<div class="content">
			<section class="section-1">
				<div class="slogan-wrapper">
					<div class="slogan">MAKE YOUR GAME HIT AROUND</div>
					<router-link to="/submit">
						<div class="submit-button" @click="sendGa">SUBMIT YOUR GAME</div>
					</router-link>
				</div>
				<img src="../assets/img/Publishing-top.jpg" alt="" class="background">
			</section>
			<section class="section-2">
				<ul class="describe">
					<li class="describe-item">
						<div class="l">
							<img src="../assets/img/01.png" alt="">
						</div>
						<div class="r">
							<div class="inner">
								<h4>Product</h4>
								<p>Highly optimize your game</p>
								<p>An experitmented team to offer advice on allgame items,including,UI,UX and much more.</p>
							</div>
						</div>
					</li>
					<li class="describe-item">
						<div class="l">
							<img src="../assets/img/02.png" alt="">
						</div>
						<div class="r">
							<div class="inner">
								<h4>User acquisition</h4>
								<p>Financial risks and user acquisition are on us</p>
								<p>ROI strategy allows us to buy  volumes with CPI 3-4times cheaper than market standards.</p>
							</div>
						</div>
					</li>
					<li class="describe-item">
						<div class="l">
							<img src="../assets/img/03.png" alt="">
						</div>
						<div class="r">
							<div class="inner">
								<h4>Monetization</h4>
								<p>Help you make the maximum value from you game</p>
								<p>An expertised ad mediation system increases your revenue from 300% to 1000% and higher.</p>
							</div>
						</div>
					</li>
					<li class="describe-item">
						<div class="l">
							<img src="../assets/img/04.png" alt="">
						</div>
						<div class="r">
							<div class="inner">
								<h4>Data analysis</h4>
								<p>Offer help to improve your game and understand your users more</p>
								<p>Tons of A/B tests,methods to improve and IAP and much</p>
								<p>more will be offered by analyzing data.</p>
							</div>
						</div>
					</li>
				</ul>
			</section>
		</div>
		<FooterComponent></FooterComponent>
	</div>
</template>

<script>
	import HeaderComponent from '../components/Header.component.vue';
	import FooterComponent from '../components/Footer.component.vue';

	export default {
		name: 'home',

		components: {
			HeaderComponent,
			FooterComponent
		},
		methods: {
		    sendGa(){
                this.$ga.event({
                    eventCategory: 'submit you game',
                    eventAction: 'click',
                    eventLabel: 'submit your game',
                });
			}
		}

	};
</script>

<style lang="less" scoped>
	.mobile {
		.cmplay-home-container {
			.content {
				.section-1 {
					img {
						height: 100%;
					    width: auto!important;
					    max-width: fit-content;
					}
					.slogan-wrapper {
						width: 90%;
						.slogan {
							font-size: .8rem;
						}
						.submit-button {
							max-width: none;
							padding: 18px 25px;
						}
					}

				}
				.section-2 {
					.describe {
						width: 90%;
						.describe-item {
							flex-direction: column;
							.l, .r {
								flex: 1 !important;
							}
							.l {
								img {
									width: 126px;
								}
							}
							.r {
								.inner {
									position: relative;
									top: auto;
									transform: none;
								}
							}
						}
					}
				}
			}
		}
	}

	.cmplay-home-container {
		font-family: lato, helvetica, sans-serif;
		.content {
			.section-1 {
				overflow: hidden;
			    height: 640px;
			    position: relative;

				.slogan-wrapper {
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate3d(-50%, -50%, 0);
					width: 80%;
					text-align: center;

					.slogan {
						margin-bottom: 48px;
						font-size: 40px;
						font-weight: 700;
						color: #ffffff;
						text-align: center;
					}

					.submit-button {
						border: 3px solid #fff!important;
						border-radius: 100px;
					    color: #fff;
					    cursor: pointer;
					    display: inline-block;
					    font-size: 24px;
					    font-weight: 700;
					    margin: 0 auto;
					    max-width: 90%;
					    padding: 25px 45px;
					    text-decoration: none;
					    transition: background .2s;
					    border: 3px solid #fff;
					}
				}
				.background {
					position: absolute;
					width: 100%;
					top: 0;
					left: 0;
					z-index: -1;

					img {
						display: block;
						width: 100%;
					}
				}
			}
			.section-2 {
				.describe {
					width: 80%;
					margin: 0 auto;
					padding: 80px 0;

					.describe-item {
						display: flex;
						.l {
							flex: 4;
							text-align: center;

							img {
								display: inline-block;
								width: 160px;
							}
						}
						.r {
							flex: 6;
							line-height: 1.45;
							padding-left: 24px;
							position: relative;

							.inner {
								position: absolute;
								top: 50%;
								transform: translateY(-50%);

								h4 {
									font-size: 24px;
									font-weight: 600;
									margin-bottom: 8px;
								}

								p {
									font-size: 16px;
									font-weight: 400;
									font-family: "PingFang SC";
									margin-bottom: 8px;
								}

								p:nth-of-type(1){
									color: #ff5b43;
								}
							}

						}
					}
				}
			}
		}
		.footer {
			padding: 80px 0;

			.inner {
				color: #2f3c4d;
				font-size: 14px;
				width: 80%;
				margin: 0 auto;
				text-align: center;
				li {
					display: inline-block;
					margin: 0 8px;
				}
			}
		}

	}
</style>
